import { type Location } from 'history';
import qs from 'qs';
import { useHistory } from 'react-router-dom';
import { TokenLogin } from 'features/onboarding';

const getQueryParameter = (location: Location, key: string) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  const value = query[key];
  if (typeof value === 'string') {
    return value;
  }

  return undefined;
};

const PageTokenLogin = () => {
  const { replace, location } = useHistory();

  const token = getQueryParameter(location, 'login_token');
  const referrer = getQueryParameter(location, 'referrer');

  if (!token) {
    replace('/');
    return null;
  }

  const onFinish = () => {
    replace(referrer ?? '/');
  };

  return <TokenLogin loginToken={token} onFinish={onFinish} />;
};

export default PageTokenLogin;
